import { LanguageTypes, RepresentativeAccessTypes, RepresentativeTypes } from '../enums';

export interface Representative {
  $id?: string;
  RepresentativeId: number;
  CoalitionId: number;
  NameFirst: string;
  NameLast: string;
  EmailAddress?: string;
  PhoneNumber?: string;
  AccessType?: RepresentativeAccessTypes;
  LanguageType?: LanguageTypes;
  RepresentativeType?: RepresentativeTypes;
}
